import styled from '@emotion/styled';
import { globalAreaV2Sizes } from './styles';

/**
 * 従来UIの `global-area/components/Logo` は `GlobalArea` の CSS grid レイアウト
 * （`grid-column` と固定 padding）に結び付いているため、flex レイアウトの v2
 * ヘッダーでは使わずこちらを用いる。
 */

const LogoContainer = styled.div<{ isClickable: boolean }>`
  display: flex;
  align-items: flex-end;
  gap: var(--ps-space-inline);
  flex-shrink: 0;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`;

const LogoImage = styled.img`
  height: ${globalAreaV2Sizes.logoHeight};
  width: auto;
`;

/* 太さだけ役割から外している。11px を持つ `text.annotation` は 400 だが、ブランド表記なので太字を保つ。 */
const BrandLabel = styled.span`
  color: var(--ps-color-text-heading);
  font-size: var(--ps-text-annotation-size);
  font-weight: 700;
  line-height: var(--ps-text-annotation-line-height);
  padding-bottom: var(--ps-space-hairline);
`;

interface LogoV2Props {
  brandLabel?: string;
  onClick?: () => void;
  title?: string;
}

export function LogoV2({ brandLabel, onClick, title }: LogoV2Props) {
  return (
    <LogoContainer isClickable={onClick !== undefined} onClick={onClick} title={title}>
      <LogoImage id="logo" className="logo-image" src="images/proplus_logo.png" alt="ProPlus+" />
      {brandLabel && <BrandLabel>{brandLabel}</BrandLabel>}
    </LogoContainer>
  );
}
